export const navRoutes = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/list-property', label: 'List Property' },
    { path: '/contact', label: 'Contact' },
  ];